import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';

import { CEUMA_URL_API } from 'app/config';

import { Curso, DetalheCurso } from 'models/curso';
import { Campus } from 'models/campus';

import DetalhesCursos from 'mocks/cursos/graduacao/graduacao-cursos-detalhes';
import CampiMock from 'mocks/cursos/campi.json';
import GradeMock from 'mocks/cursos/graduacao/grade-curricular.json';
import CursosMock from 'mocks/cursos/graduacao/cursos-graduacao.json';
import CursosLegendasMock from 'mocks/cursos/graduacao/cursos-legendas.json';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

const isCache = (data) => data instanceof Array && data.length > 0;

export const CURSOS_URL = `${CEUMA_URL_API}/curso/cursos`;
export const VALORES_CURSOS_URL = `${CEUMA_URL_API}/recuperaValorCurso`;
const filtarPorChaveValor = (lista: Curso[], chave, valor) => lista.filter(item => item[chave] === valor);
const filtrarCursoPorCampus = (cursos: Curso[], campusId) =>
  cursos.filter((curso) =>
    curso.campus.filter((campus) =>
      campus.id === campusId,
    ).length > 0,
  );

@Injectable()
export class CursosService {

  private cursosCache: Curso[];
  private campiCache: Campus[];

  constructor(private http: HttpClient) { }

  private filtrarLista(lista: Curso[], query): { data: Curso[], total: number } {
    let resultado = lista;

    if (query.campus) {
      resultado = filtrarCursoPorCampus(resultado, query.campus);
    }

    if (query.areaConhecimento) {
      resultado = filtarPorChaveValor(resultado, 'areaConhecimento', query.areaConhecimento);
    }

    if (query.modalidade) {
      resultado = filtarPorChaveValor(resultado, 'presencial', query.modalidade);
    }

    if (query.palavraChave) {
      resultado = this.pesquisarPalavraChave(resultado, 'nome', query.palavraChave.trim());
    }

    return {
      data: resultado,
      total: this.cursosCache.length,
    };
  }

  private requisicaoCursosRest(url, resolvido): Curso[] {
    let cursosCache;
    CursosMock.map((ies)=>{
      cursosCache = ies[environment.loginContexto=='HOMOLOG'?"CEUMA":environment.loginContexto];
    })
    this.cursosCache = cursosCache
      .map(curso => new Curso({ ...curso, gradeCurricular: GradeMock }));
    return resolvido(this.cursosCache);
  }

  private pesquisarPalavraChave(lista: Curso[], chave, valor): Curso[] {
    const result: Curso[] = lista.filter((item: Curso) => item.nome.toLocaleLowerCase().includes(valor))

    if (!result.length) {
      console.error("Nenhum curso encontrado!")
    }

    return result
  }

  private detalheCursoPorID(id: string): DetalheCurso {
    for (const key in DetalhesCursos[environment.loginContexto]) {
      if (key === id) {
        return new DetalheCurso(DetalhesCursos[environment.loginContexto][key]);
      }
    }
  }

  query(params): Promise<{ data: Curso[], total: number }> {
    return new Promise<{ data: Curso[], total: number }>((resolve, reject) => {

      if (isCache(this.cursosCache)) {
        const resultados = this.filtrarLista(this.cursosCache, params);
        resolve({...resultados});
      } else {
        this.requisicaoCursosRest(CURSOS_URL, (respostaCursos) => {
          const resultados = this.filtrarLista(respostaCursos, params);
          resolve({...resultados});
        });
      }
    });
  }

  getCurso(ids: string[], params: any = {}): Promise<Curso[]> {
    return new Promise((resolve) =>
      this.query(params).then((val) =>
        resolve(val.data.filter(curso => ids.indexOf(curso.id) >= 0)),
      ),
    );
  }

  getCursoConteudo(id: string): Promise<DetalheCurso> {
    return new Promise<DetalheCurso>((resolve) =>
      resolve(this.detalheCursoPorID(id)));
  }

  getLegendas() {
    return new Promise<any>((resolve) => resolve(CursosLegendasMock));
  }

  campus(): Promise<Campus[]> {
    return new Promise<Campus[]>((resolve) => {
      if (!isCache(this.campiCache)) {
        this.campiCache = CampiMock.map(c => new Campus(c));
      }
      resolve(this.campiCache);
    });
  }

  getValoresCurso(idCurso:string):Observable<any>{
    return this.http.get(`${VALORES_CURSOS_URL}/${idCurso}`).catch(this.errorHandler);
  }

  errorHandler(error: HttpErrorResponse){
    return Observable.throw(error.message || "Server error");
  }
}
